import { render, staticRenderFns } from "./CellaQta.vue?vue&type=template&id=6a30163f&scoped=true&"
import script from "./CellaQta.vue?vue&type=script&lang=js&"
export * from "./CellaQta.vue?vue&type=script&lang=js&"
import style0 from "./CellaQta.vue?vue&type=style&index=0&id=6a30163f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a30163f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
